<div class="row">
  <div class="col-12">
    <sb-card>
      <div card-fit>
        <sb-wizard #wizard [clickableTabs]="false">
          <sb-wizard-tab #tab1 titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings">
            <form [formGroup]="form" (ngSubmit)="nextStep(wizard, tab2);currentTab = 2"
                  class="wizard__forms px-5 pb-5">

              <div class="form-group mt-3">
                <label class="form-label" for="Type">{{ 'lang.globals.type' | translate }}<span class="red">*</span></label>
                <select id="Type" class="form-select"
                        [ngModel]="cull?.type" (ngModelChange)="setValue('type', $event)" formControlName="Type">
                  <option *ngPermissions="[permissionService.Permission.cull_player_create]"
                          [value]="'PlayerCull'">{{ 'lang.globals.player' | translate }}
                  </option>
                  <option *ngPermissions="[permissionService.Permission.cull_time_create]"
                          [value]="'TimeCull'">{{ 'lang.filterEdit.time' | translate }}
                  </option>
                  <option *ngPermissions="[permissionService.Permission.cull_client_create]"
                          [value]="'ClientCull'">{{ 'lang.globals.client' | translate }}
                  </option>
                  <option *ngPermissions="[permissionService.Permission.cull_content_create]"
                          [value]="'ContentCull'">{{ 'lang.culls.culltype.content' | translate }}
                  </option>
                  <option *ngPermissions="[permissionService.Permission.cull_geo_create]"
                          [value]="'GeoCull'">{{ 'nav.datasets.areas' | translate }}
                  </option>
                </select>
                <div *ngIf="Type.touched && Type.errors?.required"
                     class="alert alert-danger">{{ 'lang.globals.typeWarning' | translate }}
                </div>
              </div>
              <div class="form-group">
                <label class="form-label" for="FilterTitle">{{ 'lang.globals.name' | translate }}<span class="red">*</span></label>
                <input type="text" id="FilterTitle" class="form-control" [ngModel]="cull?.name"
                       (ngModelChange)="setValue('name', $event)" formControlName="Name" sbAutofocus>
                <div *ngIf="Name.touched && Name.errors?.required"
                     class="alert alert-danger">{{ 'lang.globals.nameWarning' | translate }}
                </div>
                <div *ngIf="Name.touched && Name.errors?.unique"
                     class="alert alert-danger">{{ 'lang.globals.uniqueNameWarning' | translate }}
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12">
                  <div class="form-group d-grid">
                    <label class="form-label" for="Company">{{ 'lang.globals.company' | translate }}</label>
                    <button [disabled]="cullId || companyDisabled" (click)="selectCompany()" type="button" id="Company"
                            class="btn btn-secondary  text-center">
                      <sb-icon class="mr-1" icon="company"></sb-icon>
                      {{ cull?.company ? cull?.company?.name : translate.instant('lang.globals.default') }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="my-2">{{ 'lang.globals.cullCategory'|translate }}</div>
                  <sb-comp-selection [display]="cull?.category"
                                     (selectClicked)="selectCategory()"
                                     (createClicked)="createCategory()"
                                     (deleteClicked)="deleteCategory()"></sb-comp-selection>
                </div>
                <div class="col">
                  <div class="my-2">{{ 'lang.globals.color'|translate }}</div>
                  <div #colorPickerElement
                       class="tw-w-40 tw-h-15 tw-border-2 tw-border-solid tw-rounded"
                       [style.backgroundColor]="'#'+(cull?.color??'000000')"
                       (colorPickerCancel)="cancelColor()"
                       (colorPickerSelect)="setColor($event)"
                       (cpPresetColorsChange)="colorService.setColor($event)"
                       [colorPicker]="'#'+(cull?.color??'000000')"
                       [(cpToggle)]="showColorPicker"
                       [cpAddColorButtonText]="'lang.globals.addColorLabel' | translate"
                       [cpAddColorButton]="checkColorSavePermission()"
                       [cpAlphaChannel]="'disabled'"
                       [cpCancelButtonClass]="'btn btn-danger'"
                       [cpCancelButtonText]="'lang.globals.cancel' | translate"
                       [cpCancelButton]="true"
                       [cpCloseClickOutside]="false"
                       [cpOKButtonClass]="'btn btn-primary'"
                       [cpOKButtonText]="'lang.globals.addColor' | translate"
                       [cpOKButton]="true"
                       [cpOutputFormat]="'hex'"
                       [cpMaxPresetColorsLength]="null"
                       [cpPresetColors]="colorService.colorDef"
                       [cpPresetEmptyMessage]="'lang.globals.noColorsAdded' | translate"
                       [cpPresetLabel]="'lang.globals.presetColors' | translate"
                       [cpRemoveColorButtonClass]="checkColorDeletePermission()"
                       [cpSaveClickOutside]="false"
                       [cpUseRootViewContainer]="false"
                       [cpWidth]="'255px'" style="z-index: 999;">
                  </div>
                </div>
              </div>
              <div *ngIf="this.hidden" class="form-group">
                {{ 'lang.filterEdit.saveForLater' | translate }}
              </div>
              <div class="wizard__footerActions">
                <button (click)="cancel()" type="button"
                        class="btn btn-default">{{ 'lang.globals.cancel' | translate }}
                </button>
                <button (click)="nextStep(wizard, tab2);currentTab = 2" class="btn btn-primary" type="button"
                        [disabled]="!form.valid || !cull?.type">{{ 'lang.globals.next' | translate }}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
          <sb-wizard-tab #tab2 titleText="{{ 'lang.wizard.tabs.filterSettings' | translate }}" icon="bookings"
                         [disabled]="!form.valid">
            <div class="text-center mb-5">
              <button type="button"
                      *ngIf="easyMode && cull?.type !== 'ClientCull' && cull?.type !== 'PlayerCull' && cull?.type !== 'ContentCull'"
                      (click)="switchToAdvancedMode()"
                      class="btn btn-primary">{{ 'lang.filterEdit.switchMode' | translate }}
              </button>
            </div>
            <div class="wizard__forms px-5 pb-5" *ngIf="currentTab === 2">
              <div *ngIf="cull?.type === 'TimeCull'">
                <sb-filter-time-cull [(cull)]="cull" [easyMode]="easyMode"></sb-filter-time-cull>
              </div>
              <div *ngIf="cull?.type === 'PlayerCull'">
                <sb-filter-player-cull [(cull)]="cull" [easyMode]="easyMode"></sb-filter-player-cull>
              </div>
              <div *ngIf="cull?.type === 'ClientCull'">
                <sb-filter-client-cull [(cull)]="cull" [easyMode]="easyMode" [isInModalContext]="isInModalContext"></sb-filter-client-cull>
              </div>
              <div *ngIf="cull?.type === 'ContentCull'">
                <sb-comp-filter-content-cull [(cull)]="cull" [easyMode]="easyMode"></sb-comp-filter-content-cull>
              </div>
              <div *ngIf="cull?.type === 'GeoCull'">
                <sb-filter-geo-cull [(cull)]="cull" [easyMode]="easyMode"
                                    [tabTwo]="currentTab === 2"
                                    [isInSidebarContext]="isInSidebarContext"></sb-filter-geo-cull>
              </div>
              <div class="wizard__footerActions">
                <button (click)="nextStep(wizard, tab1); currentTab = 1"
                        class="btn btn-default">{{ 'lang.globals.previous' | translate }}
                </button>
                <button
                  [type]="'button'"
                  [disabled]="nextDisable"
                  (click)="stepThree(wizard, tab3)" class="btn btn-primary"
                >{{ 'lang.globals.next' | translate }}
                </button>
              </div>
            </div>
          </sb-wizard-tab>
          <sb-wizard-tab #tab3 titleText="{{ 'lang.wizard.tabs.preview' | translate }}" icon="preview"
                         [disabled]="false">
            <div class="wizard__forms px-5 pb-5">
              <div class="row">
                <div class="container">
                  <h2>
                    {{ 'lang.globals.summary' | translate }}
                  </h2>
                </div>
              </div>
              <div class="d-flex">

                <ng-container *ngIf="currentTab === 3">
                  <sb-filter-preview *ngIf="previewComponent " [filter]="previewCull"></sb-filter-preview>
                </ng-container>
                <ng-container *ngIf="previewCull?.type === 'GeoCull' && polygonsToRender?.length > 0">
                  <sb-polygon-edit-map
                    class="ml-5"
                    [mapheight]="560"
                    [mapwidth]="560"
                    [whatIsHere]="false"
                    [polygons]="util.geo.polygonDTOArrayToPolygonArray(polygonsToRender)"
                    [readOnly]="true"
                    [nominatim]="false" [zoomControl]="false" [initialZoom]="7"
                    [roundedCorners]="true">
                  </sb-polygon-edit-map>
                </ng-container>
              </div>
              <div class="wizard__footerActions">
                <button (click)="nextStep(wizard, tab2); currentTab = 2; polygonsToRender = []"
                        class="btn btn-default">{{ 'lang.globals.previous' | translate }}
                </button>
                <button (click)="updateCull()" [disabled]="loading"
                        class="btn btn-success">{{ 'lang.globals.submit' | translate }}
                </button>
              </div>
            </div>
          </sb-wizard-tab>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
